import React, { useState } from 'react';
import { FaNetworkWired } from 'react-icons/fa';
import GraphVisualization from './GraphVisualization';

const InfoBoxes = ({ totalProposals, approvedProposals, tableData }) => {
  const [showGraph, setShowGraph] = useState(false);
  
  // The number of distinct politicians in the fotospoliticos folder
  const politiciansMapped = 38; // Based on the count from the public/fotospoliticos directory

  const handleMapClick = () => {
    // Open the graph visualization
    setShowGraph(true);
  };

  const handleCloseGraph = () => {
    setShowGraph(false);
  };

  return (
    <>
      <div className="info-boxes-container">
        <div className="info-box">
          <h3>Propostas Rastreadas</h3>
          <div className="info-box-value">{totalProposals}</div>
        </div>
        
        <div className="info-box">
          <h3>Propostas Aprovadas</h3>
          <div className="info-box-value">{approvedProposals}</div>
        </div>
        
        <div className="info-box">
          <h3>Políticos Mapeados</h3>
          <div className="info-box-value">{politiciansMapped}</div>
        </div>
        
        <div className="info-box clickable" onClick={handleMapClick}>
          <h3>Mapa Visual</h3>
          <div className="info-box-icon">
            <FaNetworkWired size={32} />
          </div>
        </div>
      </div>
      
      {/* Graph Visualization Modal */}
      {showGraph && (
        <GraphVisualization
          data={tableData}
          onClose={handleCloseGraph}
        />
      )}
    </>
  );
};

export default InfoBoxes; 